<div class="form-group" [formGroup]="form">
  <div class="input-group">
    <input class="form-control" formControlName="{{filter.name}}" placeholder="yyyy-mm-dd" name="{{filter.name}}" id="{{filter.name}}"
      ngbDatepicker #d2="ngbDatepicker">
    <div class="input-group-append">
      <div class="input-group-text" (click)="d2.toggle()">
        <i class="fa fa-calendar" style="cursor: pointer;"></i>
      </div>
    </div>
  </div>
</div>